import React from 'react';
import { Card, Grid, Label } from 'semantic-ui-react';
import _ from 'lodash';
import { Link } from 'react-router';

import EventsFeed from '../../containers/event-feed';
import { FEED_TYPES } from '../../containers/event-feed/static';
import CampaignEmailSettings from '../../containers/campaign-email-settings';

const isEmailRecipient = member => _.includes(['TEAM_MEMBER', 'CAMPAIGN_OWNER'], member.role);

const CampaignNotificationsTab = ({ campaign }) => {
  const campaignJSON = campaign.toJSON();
  const teamMembers = _.filter(campaignJSON.members, member => isEmailRecipient(member));
  const { shortlist } = campaignJSON;
  const hasShortlist = !_.isNil(shortlist);
  const shortlistName = hasShortlist && shortlist.name;
  return (
    <div style={{ margin: 30 }}>
      <Grid fluid>
        {
          hasShortlist &&
          <Grid.Row>
            <Grid.Column width={8}>
              <Card color="blue" fluid>
                <Card.Content>
                  <table style={{ width: '100%' }}>
                    <tr>
                      <td>
                        <h4>Campaign created from SHORTLIST</h4>
                      </td>
                      <td>
                        <Link to={`/shortlists/${shortlist.id}`}>
                          <Label color="blue" basic>{shortlistName}</Label>
                        </Link>
                      </td>
                    </tr>
                  </table>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        }
        <Grid.Row>
          <Grid.Column width={8}>
            <Card color="green" fluid>
              <Card.Content>
                <div>
                  <div>
                    <h2>Email Settings</h2>
                    <p style={{ color: 'rgba(0,0,0,.4)' }}>
                    manage the automated campaign summary emails.
                    </p>
                  </div>
                </div>
                <Card fluid>
                  <Card.Content>
                    <CampaignEmailSettings campaignId={campaign.get('id')} teamMembers={teamMembers} />
                  </Card.Content>
                </Card>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={8}>
            <EventsFeed
              cardColour="pink"
              campaignId={campaign.get('id')}
              feedType={FEED_TYPES.CAMPAIGN}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default CampaignNotificationsTab;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-notifications-tab2/index.js
 **/